import React from 'react';
// import { useState } from 'react';

// import Button from '../subcomponents/Button';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { stripePublicKey } from '../../utils/Constants';
import OnboardingBox from '../OnboardingBox';
import PaymentInfoForm from './PaymentInfoForm';

const stripePromise = loadStripe(stripePublicKey);

const Payment = () => {
	// const changePageState = () => {
	// 	props?.setSubscriptionState('payment');
	// };
	return (
		<>
			<OnboardingBox>
				<div className="d-flex flex-column subscription-plan-container">

					<div className="headline-large">
						Payment Information
					</div>
					<div className="body-2" style={{ color: '#6E6B7B', fontWeight: '500', marginTop: '10px' }}>
						Enter your card information
					</div>

					<div className="paymentForm">
						<Elements stripe={stripePromise}
							options={{
								fonts: [
									{ cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:300,300i,400,500,600' }
								]
							}}
						>
							<PaymentInfoForm />
						</Elements>
					</div>

				</div>

			</OnboardingBox>
		</>
	);
};

export default Payment;